// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KvDrPB {
  position: relative;
  width: 100%;
}

.jC7NTN {
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 19.9px;
  letter-spacing: 0;
  color: var(--text-neutral-dark-gray, #1f1f1f);
  margin: 0 0 var(--spacing-1, 8px) 0;
  padding: 0;
  display: block;
}

.yd6_4X {
  width: 100%;
  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);
  padding-right: 40px;
  border: 1px solid #cccccc;
  background-color: #fafafa;
  border-radius: var(--radius-m, 4px);
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.15s ease;
  position: relative;
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 180%;
  letter-spacing: 0;
  vertical-align: middle;
  color: var(--text-neutral-dark, #1f1f1f);
}

.yd6_4X:hover:not(.iXCOHb) {
  background-color: rgba(0, 0, 0, 0.02);
}

.yd6_4X:focus {
  outline: 1px solid var(--surface-primary-medium, #d64000);
  outline-offset: 1px;
}

.yd6_4X.iXCOHb {
  cursor: not-allowed;
  opacity: 0.6;
  background-color: var(--surface-neutral-pale, #f5f5f5);
}

.yd6_4X.OhsxeZ {
  border-color: var(--surface-error-medium, #dc2626);
}

.yd6_4X.gI25IT {
  min-height: 32px;
  font-size: 12px;
}

.yd6_4X.igQkvb {
  min-height: 40px;
  font-size: 14px;
}

.yd6_4X.MOfhWs {
  min-height: 48px;
  font-size: 16px;
}

.BEAoly {
  flex: 1;
  text-align: left;
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 180%;
  letter-spacing: 0;
  color: var(--text-neutral-dark);
}

.BEAoly:empty::before {
  content: attr(data-placeholder);
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 180%;
  letter-spacing: 0;
  color: var(--text-neutral-strong-gray, #999999);
}

.yxwypY {
  color: #d64000;
  width: var(--spacing-2, 16px);
  height: var(--spacing-2, 16px);
  transition: transform 0.2s ease;
  position: absolute;
  right: var(--spacing-2, 16px);
  pointer-events: none;
}

.MHGjmD {
  transform: rotate(180deg);
}

.OVu3j5 {
  animation: J6Z99j 1s linear infinite;
}

@keyframes J6Z99j {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Xi2Ibq {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: var(--surface-neutral-white);
  border: 1px solid #cccccc;
  border-top: none;
  border-radius: 0 0 var(--radius-m, 4px) var(--radius-m, 4px);
  box-shadow: var(--shadow-sm, 0px 4px 8px 0px rgba(0, 0, 0, 0.15));
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  animation: UyBwAU 0.2s ease-out;
}

.CwPMaD {
  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 180%;
  letter-spacing: 0;
  color: var(--text-neutral-dark);
  background-color: var(--surface-neutral-white);
  cursor: pointer;
  transition: background-color 0.15s ease;
  display: flex;
  align-items: center;
  border: none;
  width: 100%;
  text-align: left;
}

.CwPMaD:hover:not(.iXCOHb) {
  background-color: var(--primary-orange-200, #ffeee5);
}

.CwPMaD.DjW_el {
  background-color: var(--surface-primary-medium, #d64000) !important;
  color: #ffffff;
  font-weight: var(--font-weight-semibold, 600);
}

.CwPMaD.iXCOHb {
  cursor: not-allowed;
  opacity: 0.6;
  color: var(--text-neutral-medium, #666666);
}

.CwPMaD.gI25IT {
  min-height: 32px;
  font-size: 12px;
}

.CwPMaD.igQkvb {
  min-height: 40px;
  font-size: 14px;
}

.CwPMaD.MOfhWs {
  min-height: 48px;
  font-size: 16px;
}

@keyframes UyBwAU {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.okfi26 {
  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);
  border-bottom: 1px solid #e5e5e5;
  background-color: var(--surface-neutral-pale, #f9f9f9);
}

.iCFYH4 {
  width: 100%;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border: 1px solid #cccccc;
  border-radius: var(--radius-s, 2px);
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 14px;
  line-height: 1.4;
  color: var(--text-neutral-dark);
  background-color: var(--surface-neutral-white);
  outline: none;
  transition: border-color 0.15s ease;
}

.iCFYH4:focus {
  border-color: var(--surface-primary-medium, #d64000);
  outline: 1px solid var(--surface-primary-medium, #d64000);
  outline-offset: 1px;
}

.iCFYH4::placeholder {
  color: var(--text-neutral-medium, #999999);
}

.WO7UCl {
  padding: var(--spacing-2, 16px);
  text-align: center;
  color: var(--text-neutral-medium, #666666);
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 14px;
  font-style: italic;
  background-color: var(--surface-neutral-pale, #f9f9f9);
}

@media (max-width: 768px) {
  .jC7NTN {
    margin-bottom: var(--spacing-1, 8px);
  }

  .yd6_4X {
    padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
    padding-right: 36px;
  }

  .CwPMaD {
    padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  }
}

.gRhW3I {
  display: flex;
  margin-top: var(--spacing-0-5);
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-0-5);
}

.YyxdzZ {
  height: 12px;
  width: 12px;
}

.kFjdPu {
  margin: 0;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
  font-size: var(--font-size-sm);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Dropdown/Dropdown.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,mCAAmC;EACnC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qDAAqD;EACrD,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sDAAsD;AACxD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8CAA8C;EAC9C,yBAAyB;EACzB,gBAAgB;EAChB,4DAA4D;EAC5D,iEAAiE;EACjE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,+BAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,8CAA8C;EAC9C,eAAe;EACf,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mEAAmE;EACnE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qDAAqD;EACrD,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,uDAAuD;EACvD,yBAAyB;EACzB,mCAAmC;EACnC,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,8CAA8C;EAC9C,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,oDAAoD;EACpD,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,0CAA0C;EAC1C,qDAAqD;EACrD,eAAe;EACf,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,uDAAuD;IACvD,mBAAmB;EACrB;;EAEA;IACE,uDAAuD;EACzD;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,uCAAuC;EACvC,mCAAmC;EACnC,8BAA8B;AAChC","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n}\n\n.label {\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 400;\n  font-style: normal;\n  font-size: 14px;\n  line-height: 19.9px;\n  letter-spacing: 0;\n  color: var(--text-neutral-dark-gray, #1f1f1f);\n  margin: 0 0 var(--spacing-1, 8px) 0;\n  padding: 0;\n  display: block;\n}\n\n.dropdownTrigger {\n  width: 100%;\n  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);\n  padding-right: 40px;\n  border: 1px solid #cccccc;\n  background-color: #fafafa;\n  border-radius: var(--radius-m, 4px);\n  cursor: pointer;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: background-color 0.15s ease;\n  position: relative;\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 400;\n  font-style: normal;\n  font-size: 14px;\n  line-height: 180%;\n  letter-spacing: 0;\n  vertical-align: middle;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.dropdownTrigger:hover:not(.disabled) {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n.dropdownTrigger:focus {\n  outline: 1px solid var(--surface-primary-medium, #d64000);\n  outline-offset: 1px;\n}\n\n.dropdownTrigger.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n  background-color: var(--surface-neutral-pale, #f5f5f5);\n}\n\n.dropdownTrigger.error {\n  border-color: var(--surface-error-medium, #dc2626);\n}\n\n.dropdownTrigger.small {\n  min-height: 32px;\n  font-size: 12px;\n}\n\n.dropdownTrigger.medium {\n  min-height: 40px;\n  font-size: 14px;\n}\n\n.dropdownTrigger.large {\n  min-height: 48px;\n  font-size: 16px;\n}\n\n.dropdownValue {\n  flex: 1;\n  text-align: left;\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 400;\n  font-style: normal;\n  font-size: 14px;\n  line-height: 180%;\n  letter-spacing: 0;\n  color: var(--text-neutral-dark);\n}\n\n.dropdownValue:empty::before {\n  content: attr(data-placeholder);\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 400;\n  font-style: normal;\n  font-size: 14px;\n  line-height: 180%;\n  letter-spacing: 0;\n  color: var(--text-neutral-strong-gray, #999999);\n}\n\n.dropdownIcon {\n  color: #d64000;\n  width: var(--spacing-2, 16px);\n  height: var(--spacing-2, 16px);\n  transition: transform 0.2s ease;\n  position: absolute;\n  right: var(--spacing-2, 16px);\n  pointer-events: none;\n}\n\n.dropdownIconOpen {\n  transform: rotate(180deg);\n}\n\n.loadingIcon {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.dropdownOptions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: var(--surface-neutral-white);\n  border: 1px solid #cccccc;\n  border-top: none;\n  border-radius: 0 0 var(--radius-m, 4px) var(--radius-m, 4px);\n  box-shadow: var(--shadow-sm, 0px 4px 8px 0px rgba(0, 0, 0, 0.15));\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n  animation: dropdownSlideDown 0.2s ease-out;\n}\n\n.dropdownOption {\n  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 400;\n  font-style: normal;\n  font-size: 14px;\n  line-height: 180%;\n  letter-spacing: 0;\n  color: var(--text-neutral-dark);\n  background-color: var(--surface-neutral-white);\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  display: flex;\n  align-items: center;\n  border: none;\n  width: 100%;\n  text-align: left;\n}\n\n.dropdownOption:hover:not(.disabled) {\n  background-color: var(--primary-orange-200, #ffeee5);\n}\n\n.dropdownOption.selected {\n  background-color: var(--surface-primary-medium, #d64000) !important;\n  color: #ffffff;\n  font-weight: var(--font-weight-semibold, 600);\n}\n\n.dropdownOption.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n  color: var(--text-neutral-medium, #666666);\n}\n\n.dropdownOption.small {\n  min-height: 32px;\n  font-size: 12px;\n}\n\n.dropdownOption.medium {\n  min-height: 40px;\n  font-size: 14px;\n}\n\n.dropdownOption.large {\n  min-height: 48px;\n  font-size: 16px;\n}\n\n@keyframes dropdownSlideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.searchContainer {\n  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);\n  border-bottom: 1px solid #e5e5e5;\n  background-color: var(--surface-neutral-pale, #f9f9f9);\n}\n\n.searchInput {\n  width: 100%;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border: 1px solid #cccccc;\n  border-radius: var(--radius-s, 2px);\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--text-neutral-dark);\n  background-color: var(--surface-neutral-white);\n  outline: none;\n  transition: border-color 0.15s ease;\n}\n\n.searchInput:focus {\n  border-color: var(--surface-primary-medium, #d64000);\n  outline: 1px solid var(--surface-primary-medium, #d64000);\n  outline-offset: 1px;\n}\n\n.searchInput::placeholder {\n  color: var(--text-neutral-medium, #999999);\n}\n\n.noResults {\n  padding: var(--spacing-2, 16px);\n  text-align: center;\n  color: var(--text-neutral-medium, #666666);\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 14px;\n  font-style: italic;\n  background-color: var(--surface-neutral-pale, #f9f9f9);\n}\n\n@media (max-width: 768px) {\n  .label {\n    margin-bottom: var(--spacing-1, 8px);\n  }\n\n  .dropdownTrigger {\n    padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n    padding-right: 36px;\n  }\n\n  .dropdownOption {\n    padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  }\n}\n\n.messageContainer {\n  display: flex;\n  margin-top: var(--spacing-0-5);\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-0-5);\n}\n\n.messageIcon {\n  height: 12px;\n  width: 12px;\n}\n\n.errorMessage {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n  font-size: var(--font-size-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `KvDrPB`,
	"label": `jC7NTN`,
	"dropdownTrigger": `yd6_4X`,
	"disabled": `iXCOHb`,
	"error": `OhsxeZ`,
	"small": `gI25IT`,
	"medium": `igQkvb`,
	"large": `MOfhWs`,
	"dropdownValue": `BEAoly`,
	"dropdownIcon": `yxwypY`,
	"dropdownIconOpen": `MHGjmD`,
	"loadingIcon": `OVu3j5`,
	"spin": `J6Z99j`,
	"dropdownOptions": `Xi2Ibq`,
	"dropdownSlideDown": `UyBwAU`,
	"dropdownOption": `CwPMaD`,
	"selected": `DjW_el`,
	"searchContainer": `okfi26`,
	"searchInput": `iCFYH4`,
	"noResults": `WO7UCl`,
	"messageContainer": `gRhW3I`,
	"messageIcon": `YyxdzZ`,
	"errorMessage": `kFjdPu`
};
module.exports = ___CSS_LOADER_EXPORT___;
